import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const chipVariants = cva(
  "inline-flex items-center gap-1.5 h-8 px-3.5 rounded-pill text-[13px] font-medium cursor-pointer transition-colors duration-short ease-default whitespace-nowrap border-0 focus-visible:outline-2 focus-visible:outline-electric-700 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-40",
  {
    variants: {
      variant: {
        default: "bg-fog text-ink hover:bg-fog-dark",
        active: "bg-electric-50 text-electric-800",
        electric: "bg-electric-700 text-white hover:bg-electric-800",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

interface ChipProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "className">,
    VariantProps<typeof chipVariants> {
  className?: string;
}

function Chip({ variant, className, children, ...props }: ChipProps) {
  return (
    <button type="button" className={cn(chipVariants({ variant }), className)} {...props}>
      {children}
    </button>
  );
}

export { Chip, type ChipProps };
